import React from 'react';
import { Link, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { Settings, MapPin, Wrench, FileSpreadsheet, LogOut, Building2, BarChart, FileText, HelpCircle } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

export function AdminLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  // Redirect if not authenticated
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/admin/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-white shadow-md min-h-screen">
          <div className="p-4">
            <h1 className="text-xl font-bold text-blue-600">Admin Panel</h1>
          </div>
          <nav className="mt-4 space-y-1">
            <Link
              to="/admin/analytics"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <BarChart className="w-5 h-5 mr-2" />
              Analytics
            </Link>
            <Link
              to="/admin/settings"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <Settings className="w-5 h-5 mr-2" />
              Site Settings
            </Link>
            <Link
              to="/admin/plumbers"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <Building2 className="w-5 h-5 mr-2" />
              Plumbers
            </Link>
            <Link
              to="/admin/states"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <MapPin className="w-5 h-5 mr-2" />
              States & Cities
            </Link>
            <Link
              to="/admin/services"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <Wrench className="w-5 h-5 mr-2" />
              Services
            </Link>
            <Link
              to="/admin/import"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <FileSpreadsheet className="w-5 h-5 mr-2" />
              Import Data
            </Link>
            <Link
              to="/admin/articles"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <FileText className="w-5 h-5 mr-2" />
              Articles
            </Link>
            <Link
              to="/admin/faqs"
              className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <HelpCircle className="w-5 h-5 mr-2" />
              FAQs
            </Link>
            <button
              onClick={handleSignOut}
              className="w-full flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              <LogOut className="w-5 h-5 mr-2" />
              Sign Out
            </button>
          </nav>
        </div>

        {/* Main content */}
        <div className="flex-1 p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}